import CpReplaceMenu from './CpReplaceMenu';

export default {
  __init__: ['CpReplaceMenu'],
  CpReplaceMenu: ['type', CpReplaceMenu]
};
